import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  ${(props) => props.theme.css.container};

  h1 {
    font-weight: 500;
  }

  .confirmation {
    width: 100%;
    padding: 5px 10px;
    background: ${(props) => props.theme.palette.general.greyLight};
    text-transform: uppercase;

    h3 {
      margin: 0;
    }
  }

  .posts {
    padding: 0;

    .action {
      text-decoration: none;
      margin-left: auto;
    }

    h2 {
      font: ${font('default', 'normal', '28px/1')};
      padding-bottom: 10px;
      border-bottom: 1px solid ${(props) => props.theme.palette.general.grey};
    }

    .posts-grid {
      width: 100% !important;

      .item {
        margin-bottom: 15px;
        padding-bottom: 15px;

        &:not(:last-child) {
          border-bottom: 1px solid ${(props) => props.theme.palette.general.greyLight};
        }
      }
    }
  }
`

export const PrincipalWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 30px 0;

  > div {
    width: 50%;
    ${bp('sm')`
      width: 100%;
    `}
  }

  .orderDetails {
    .orderComplete {
      font: ${font('default', 'normal', '22px/1')};
      margin-bottom: 30px;
    }

    a {
      text-decoration: none;
      color: ${(props) => props.theme.palette.general.pinkDark};
      font-weight: 500;
    }
  }
`

export const OrderSuccessContentWrapper = styled.div`
  margin-bottom: 40px;
  margin-top: 40px;
  width: 100%;
`
